import React from 'react'
import {
  Dialog,
  DialogProps,
} from 'components/Dialog'
import { useViewport } from 'hooks'

export type FiltersDialogProps = DialogProps

export const FiltersDialog: React.FC<FiltersDialogProps> = ({ ...props }) => {
  const { isMedium} = useViewport()

  return <Dialog fullScreen={!isMedium} {...props as DialogProps} />
}

export default FiltersDialog
